module.exports = __webpack_public_path__ + "img/heart.feeeb500.png";